import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SingleVideo from "../../content/pages/sound design/SingleVideo";
import SampleLibraries from "../../content/pages/sound design/SampleLibraries";
import { useAppContext } from "../../lib/AppContext";
import "./SoundDesign.scss";

// The hash makes each tab linkable, e.g. /sound-design#sample-libraries
const TABS = [
  { id: "visual-media", label: "Visual Media & Sound Design" },
  { id: "sample-libraries", label: "Virtual Instruments & Sample Libraries" },
];

function SoundDesign() {
  const { soundDesigns } = useAppContext();
  const [playingVideo, setPlayingVideo] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const hashTab = location.hash.slice(1);
  const activeIndex = Math.max(
    0,
    TABS.findIndex((tab) => tab.id === hashTab)
  );
  const activeTab = TABS[activeIndex].id;

  const selectTab = (id) => {
    navigate({ hash: id }, { replace: true });
  };

  return (
    <div className="section-sound-design">
      <div
        className="sound-design-tabs"
        role="tablist"
        aria-label="Sound design sections"
        style={{ "--active-index": activeIndex }}
      >
        <span className="sound-design-tabs-indicator" aria-hidden />
        {TABS.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            id={`tab-${tab.id}`}
            aria-selected={activeTab === tab.id}
            aria-controls={`panel-${tab.id}`}
            className={activeTab === tab.id ? "isActive" : ""}
            onClick={() => selectTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div
        key={activeTab}
        role="tabpanel"
        id={`panel-${activeTab}`}
        aria-labelledby={`tab-${activeTab}`}
        className="sound-design-panel"
      >
        {activeTab === "visual-media" ? (
          <div className="section-sound-design-videos">
            {soundDesigns.map((reel) => (
              <SingleVideo
                key={reel.id}
                reel={reel}
                isPlaying={playingVideo === reel.id}
                onPlay={setPlayingVideo}
              />
            ))}
          </div>
        ) : (
          <SampleLibraries />
        )}
      </div>
    </div>
  );
}

export default SoundDesign;
